import { render, staticRenderFns } from "./ElementScaleUnitSelect.vue?vue&type=template&id=804296c6"
import script from "./ElementScaleUnitSelect.vue?vue&type=script&lang=js"
export * from "./ElementScaleUnitSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports